import React from 'react'
import SearchTable from './SearchTable'
import { connect } from 'react-redux'
import { filterAction } from '../../actions/action'
import { addAlert } from '../../actions/alerts';
import { updateCommentLocal, updateCommentRemote } from '../../actions/comment';
import { Row, Col, Button } from 'react-bootstrap'
import { filterVariants } from './utils/variantFilters';
import * as XLSX from "xlsx";
import cloneDeep from 'lodash/cloneDeep'

class SNV extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: 'SNV2',
            dispNote: false,
            snvtab: "1"
            // filters: this.state.globalFilters[this.state]
        }
        this.multiselectRef = React.createRef()
    }

    // onFiltersChanged = (x) => {
    //     this.setState({ filters: x })
    // }

    changeSNV = () => {
        this.setState({ snvtab: this.state.snvtab == "1" ? "2" : "1" })
    }

    exportRun = (data) => {
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";


        const merged = Object.entries(data)
            .filter(([_, rows]) => Array.isArray(rows))
            .flatMap(([sample, rows]) =>
                rows.map(row => ({
                    Sample: sample,
                    ...row,
                }))
            );

        // Convert to worksheet
        const worksheet = XLSX.utils.json_to_sheet(merged);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

        // Save
        XLSX.writeFile(workbook, [this.props.run, 'export'].join('_') + fileExtension);
    }

    render() {
        const filters = this.props.globalFilters[this.props.preset]?.SNV2?.filters || [];

        const activeFilters = filters.filter(
            f => f.value !== "" && f.value !== null
        );

        const filteredData1 = this.props.data ? Object.keys(filters).length
            ? filterVariants(this.props.data, activeFilters)
            : this.props.data : null

        const filteredData2 = this.props.data2 ? Object.keys(filters).length
            ? filterVariants(this.props.data2, activeFilters)
            : this.props.data2 : null

        const key = v =>
            `${v.Chromosome}:${v.Start_Position}:${v.Reference_Allele}:${v.Tumor_Seq_Allele2}`;

        const ids = filteredData1 ? new Set(filteredData1?.map(key)) : null;

        var uniqueData2 = filteredData2 ? filteredData2?.filter(v => !ids.has(key(v))) : null
        uniqueData2 = uniqueData2?.length > 0 ? uniqueData2 : [{ Header: "No data" }];



        return (
            this.props.data === null ?
                <h1> select a sample </h1> :
                !this.props.data ?
                    <h1> SNV data not available for this sample </h1> :
                    <div>
                        <Row>
                            <Col xs={6} style={{ display: filteredData2 ? "contents" : "none", paddingRight: '15px' }}>
                                <h5>Table not filtered for quality has {uniqueData2[0].Header != "No data" ? uniqueData2?.length : 0} more variants for current filters</h5>
                            </Col>
                            <Col xs={2} style={{ display: (filteredData2 || (!filteredData2 & this.state.snvtab == "2")) ? "block" : "none" }}>
                                <Button variant={this.state.snvtab == '1' ? "secondary" : 'warning'} size="sm" className="fillAvailableBtns" onClick={this.changeSNV}>{this.state.snvtab == '1' ? "Show EXTRA variants from unfiltered table" : "Return to quality filtered table"}</Button>
                            </Col>
                            <Col></Col>
                            <Col style={{ padding: "5px" }} xs={2}>
                                <Button variant={"secondary"} size="sm" className="fillAvailableBtns" onClick={() => this.exportRun(this.props.fullrun)}>Export whole run</Button>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <SearchTable
                                    data={this.state.snvtab == '1' ? this.props.data : uniqueData2}
                                    run={this.props.run}
                                    sample={this.props.sample}
                                    user={this.props.user}
                                    table={"SNV2"}
                                    snvtab={this.state.snvtab}
                                // onFiltersChanged={this.onFiltersChanged}
                                />
                            </Col>
                        </Row>
                    </div >
        )
    }
}

//Passing global state as props (redux)
const mapStateToProps = (state) => {
    return {
        preset: state.preset,
        run: state.run,
        sample: state.sample,
        user: state.user,
        globalFilters: state.globalFilters,
        columns: state.columns,
        commentLocal: state.comment.commentLocal,
        commentRemote: state.comment.commentRemote
    }
}
const mapDispatchToProps = { filterAction, addAlert, updateCommentLocal, updateCommentRemote } // WARNING THIS SHIT CANNOT BE FUNCTION IT MUST BE AN OBJECT OR YOU WILL WASTE YOUR DAY ON THIS TUTORIALS LIE 
export default connect(mapStateToProps, mapDispatchToProps)(SNV)